<template>
  <div id="game">

    <component
      class="mx-auto my-3"
      v-bind:is="currentState"
      v-on:next="next"
      v-on:send-request="sendRequest"
      v-on:proceed-state="proceedState"
      v-on:show-text="openSnackbar"
      v-on:send-modal="sendModal"
    />

    <!-- <v-btn v-on:click="nextState" color="primary">[DEBUG]次へいく</v-btn><br>
    <v-btn v-on:click="beforeState" color="primary">[DEBUG]戻る</v-btn> -->

    <v-snackbar
      v-model="isShow"
      color="rgba(0,0,0,0)"
      :timeout="0"
      top
    >
    <div style="margin-top: -8px; margin-bottom: -12px;width: 100%">
      <div style="margin: 0 -16px">
        <template v-for="(message, index) in snackTexts">
          <snackbarMessage
            :key="message.state"
            @remove="removeMessage(index)"
            :message="message"
          />
          <div
            style="margin:4px 0;"
            v-if="index != snackTexts.length"
            :key="`${message.state}-divider`"
          />
        </template>
      </div>
    </div>
  </v-snackbar>
  </div>
</template>

<script>
import ready from '@/components/gameComponents/Ready.vue'
import checkingRole from '@/components/gameComponents/CheckingRole.vue'
import checkingPlot from '@/components/gameComponents/CheckingPlot.vue'
import waitTrust from '@/components/gameComponents/WaitTrust.vue'
import assigningPlots from '@/components/gameComponents/AssigningPlots.vue'
import waitImmediateEffect from '@/components/gameComponents/WaitImmediateEffect.vue'
import assigningMission from '@/components/gameComponents/AssigningMission.vue'
import waitPrevoting from '@/components/gameComponents/WaitPrevoting.vue'
import voting from '@/components/gameComponents/Voting.vue'
import waitDecline from '@/components/gameComponents/WaitDecline.vue'
import waitSpotlight from '@/components/gameComponents/WaitSpotlight.vue'
import runningMission from '@/components/gameComponents/RunningMission.vue'
import waitWatcher from '@/components/gameComponents/WaitWatcher.vue'
import missionCompleted from '@/components/gameComponents/MissionCompleted.vue'
import waitStrongLeader from '@/components/gameComponents/WaitStrongLeader.vue'
import result from '@/components/gameComponents/Result.vue'

import snackbarMessage from './SnackbarMessage.vue';
export default {
  name: 'game',
  props: [],
  components: {
    ready,
    checkingRole,
    checkingPlot,
    waitTrust,
    assigningPlots,
    waitImmediateEffect,
    assigningMission,
    waitPrevoting,
    voting,
    waitDecline,
    waitSpotlight,
    runningMission,
    waitWatcher,
    missionCompleted,
    waitStrongLeader,
    result,

    snackbarMessage
  },
  data() {
    return {
      current: 0,
      components: [
        'ready',
        'checkingRole',
        'checkingPlot',
        'waitTrust',
        'assigningPlots',
        'waitImmediateEffect',
        'assigningMission',
        'waitPrevoting',
        'voting',
        'waitDecline',
        'waitSpotlight',
        'runningMission',
        'waitWatcher',
        'missionCompleted',
        'waitStrongLeader',
        'result'
      ],

      snackTexts: [],
      isShow: false,
    }
  },
  computed: {
    currentState: function() {
      return this.components[this.current];
    },
    socket(){
      return this.$store.state.webSocket.socket
    }
  },
  methods: {
    next: function(e){
      console.log("catch Event:" + e.name + " "+ e.target);
      this.nextState();
    },
    nextState(){
      this.current = (this.current + 1 ) % this.components.length;
    },
    beforeState(){
      this.current = (this.current - 1 ) % this.components.length;
    },
    proceedState(nextState){
      this.current = this.components.indexOf(nextState)

      if (nextState != "ready"){
        this.$emit('start-game')
      }

    },
    sendRequest(json) {
      console.log(this.snackTexts.length > 0)
      if (this.snackTexts.length > 0){
        console.log('送信エラー')
        var modalContent = {title: "送信エラー", text: "メッセージを全て確認し消してから，\nもう一度ボタンを押して下さい．"}
        this.$emit('show-modal', modalContent)
        return
      }
      console.log("snack length: " + this.snackTexts.length)
      console.log("Sending Message...")
      console.log(json)
      this.socket.send(JSON.stringify(json))
    },
    sendPeriodicRequest (){
      console.log("Sending Periodic Message...")
      this.socket.send(JSON.stringify({}))
    },
    openSnackbar(text) {
      this.isShow = true
      this.snackTexts.unshift(text)
      this.$store.commit('incrementSnackNum')
    },
    removeMessage(index) {
      // this.snackTexts[index].show = false
      this.snackTexts.splice(index, 1);
      console.log(this.snackTexts)
      if (this.snackTexts.length == 0){
        this.isShow = false
      }
      this.$store.commit('decrementSnackNum')
    },
    sendModal: function(content) {
      // this.test = plotId
      // var plotEffect = this.$store.getters.getPlotEffect(plotId);
      // var modalContent = {title: plotEffect.name, text: plotEffect.effect}
      this.$emit('show-modal', content)
    }
  },
  created() {
    var self = this
    this.timer = setInterval(function() {self.sendPeriodicRequest()}, 300000)
  }
}

</script>

<style>
.agree {
  margin-right: 12px;
  background-color: #FFFFFF
}
.disagree {
  background-color: #FFFFFF
}
.send-button {

}
</style>
